import { useEffect, PropsWithChildren } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { useDebounce } from 'hooks/useDebounce';
import { ControlledInput } from 'components/Inputs/ControlledInput';
import SelectComponent from 'components/Inputs/SelectComponent';
import { ISelectStyleProps } from 'components/Inputs/SelectComponent/types';
import { statusOptions, defaultValues } from './constants';
import {
  IRequestsTableFiltersForm,
  IRequestsTableFiltersFormFields,
  RequestsTableFiltersFormGeneric,
  RequestsTableFiltersTransFields,
} from './types';
import { requestsTableFiltersTranslations } from './translations';
import styles from './requestsTableFiltersForm.module.scss';
import { makeSelectOptions } from 'utils/makeSelectOptions';
import { StatusType } from 'types/common';

const selectStyles: ISelectStyleProps = {
  containerStyles: {
    marginBottom: 0,
    width: 200,
    backgroundColor: 'white',
    borderRadius: 32,
  },
  controlStyles: {
    background: 'white',
    borderRadius: 32,
  },
};

const RequestsTableFiltersForm = function <T>({
  data,
  setFiltredData,
}: PropsWithChildren<IRequestsTableFiltersForm<RequestsTableFiltersFormGeneric<T>>>) {
  const { t } = useMyTranslations<RequestsTableFiltersTransFields>([requestsTableFiltersTranslations.name]);

  const useFormMethods = useForm<IRequestsTableFiltersFormFields>({ defaultValues });

  const { watch, getValues, setValue } = useFormMethods;

  const searchD = useDebounce(watch('search'));

  useEffect(() => {
    const status = getValues('status');
    if (!searchD) setFiltredData(data.filter((item) => item.status === status));
    else
      setFiltredData(
        data.filter(
          (item) =>
            item.status === status &&
            (item.name.toLowerCase().includes(searchD.toLowerCase()) ||
              item.owner.name.toLowerCase().includes(searchD.toLowerCase()) ||
              item.owner.email.toLowerCase().includes(searchD.toLowerCase()))
        )
      );
  }, [data, searchD, watch('status')]);

  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <FormProvider {...(useFormMethods as any)}>
      <div className={styles.filters}>
        <SelectComponent
          name='status'
          options={makeSelectOptions(statusOptions)}
          onSelect={(val) => {
            setValue('status', val.value as StatusType);
          }}
          styleProps={selectStyles}
          isClearable={false}
        />
        <ControlledInput
          name='search'
          type='text'
          placeholder={t('search')}
          isRemoveMargin
          classNameProp={styles.searchInput}
        />
      </div>
    </FormProvider>
  );
};

export default RequestsTableFiltersForm;
